import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import AsyncSwitch from '~/components/ui/AsyncSwitch';
import TextInput from '~/components/ui/TextInput';
import CreateQRContentBlockLayout from '~/pages/CreateQR/components/CreateQRContentBlockLayout/CreateQRContentBlockLayout';

export default function PasswordProtectionBlock() {
  const { t } = useTranslation();

  const { control, watch, setValue } = useFormContext();

  const passwordProtectionEnabledPath = 'passwordProtection.isPasswordProtected';
  const passwordProtectionPath = 'passwordProtection.password';

  const isPasswordProtected = watch(passwordProtectionEnabledPath);
  return (
    <CreateQRContentBlockLayout type="passwordProtection" defaultExpanded={false}>
      <Controller
        control={control}
        name={passwordProtectionEnabledPath}
        render={({ field: { value, onChange, onBlur } }) => {
          return (
            <AsyncSwitch
              id={passwordProtectionEnabledPath}
              sx={{ marginBottom: '16px' }}
              label={t('basicTemplateLabels:passwordProtection.switchLabel')}
              onChange={(event) => {
                onChange(event);

                if (!event.target.checked) {
                  setValue(passwordProtectionPath, '');
                }
              }}
              checked={value ?? false}
              onBlur={onBlur}
            />
          );
        }}
      />
      <Controller
        control={control}
        name={passwordProtectionPath}
        render={({ field: { value, onChange, onBlur } }) => {
          return (
            <TextInput
              id={passwordProtectionPath}
              value={value}
              disabled={!isPasswordProtected}
              type="password"
              onChange={onChange}
              onBlur={onBlur}
              helperText={value?.length >= 128 ? t('other:maxLength', { maxLength: 128 }) : ''}
              inputProps={{ maxLength: 128 }}
              fullWidth
              label={t('basicTemplateLabels:passwordProtection.inputLabel')}
              placeholder={t('basicTemplateLabels:passwordProtection.inputPlaceholder')}
            />
          );
        }}
      />
    </CreateQRContentBlockLayout>
  );
}
